<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>


<script>

    import {getContext} from "svelte";
    import { fade } from 'svelte/transition';

    import {
        errorReasons,
        resetPasswordCode,
        resetPasswordSave
    } from "./api.svelte";

    import {
        getStatusRoute,
    } from "../utils/session";

    export const ERROR_DISAPPEAR_AFTER = 5500;

    const router = getContext('router');

    let email = '';
    let code = false;
    let password = '';

    let formError = false;
    let isLoading = false;
    let errorResetTimer = null;

    let showCodeOverlay = false;

    let startErrorResetTimer = () => {

        if (errorResetTimer) {

            clearTimeout(errorResetTimer);
        }

        errorResetTimer = setTimeout(() => {

            formError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let resetCodeHandler = () => {

        if (isLoading) return;

        if (email === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        resetPasswordCode(email).then((codeResult) => {

            isLoading = false;

            if (codeResult['status'] !== 'success') {

                // TODO: Handle errore
                console.log(codeResult);

                formError = codeResult['reason'];
                startErrorResetTimer();

                return;

            }

            showCodeOverlay = true;

        });

    };

    let resetSaveHandler = () => {

        if (isLoading) return;

        if (!code || email === '' || password === '') {

            formError = 'fill_fields';
            startErrorResetTimer();

            return;

        }

        isLoading = true;

        resetPasswordSave(code, email, password).then((res) => {

            isLoading = false;

            if (res['status'] !== 'success') {

                // TODO: Handle errore
                console.log(res);

                formError = res['reason'];
                startErrorResetTimer();
                return;

            }

            router.route('/login');

        });
    }

</script>

<div id="reset-container" class="forms-container">

    <img id="logo" src="images/logo.svg" alt="keyosh Logo">

    {#if !showCodeOverlay}

        <form on:submit|preventDefault={() => resetCodeHandler()} class="resetform forms">

            {#if formError}

                <div transition:fade class="error">

                    {errorReasons[formError]}

                </div>

            {/if}

            <input
                    bind:value={email}
                    type="email"
                    name="email"
                    placeholder="E-Mail"
            />

            <button class={(isLoading) ? 'loading btn' : 'btn'}>

                <span>Code senden</span>
                <img src="images/button-loader.svg" />

            </button>
        </form>
    {:else}

        <form on:submit|preventDefault={() => resetSaveHandler()} class="resetform forms">

            {#if formError}

                <div transition:fade class="error">

                    {errorReasons[formError]}

                </div>

            {/if}

            <input
                    bind:value={password}
                    type="password"
                    name="password"
                    placeholder="Neues Passwort"
            />

            <input
                    bind:value={code}
                    type="text"
                    name="code"
                    placeholder="Code"
            />

            <button class={(isLoading) ? 'loading btn' : 'btn'}>

                <span>Neues Passwort speichern</span>
                <img src="images/button-loader.svg" />

            </button>
        </form>

    {/if}

</div>

<style>

    img#logo {
        height: 4.26vh;
        margin-bottom: 5.86vh;
    }

    .resetform .error {
        width: 28vh;
        padding: 1.78vh;
        margin-bottom: 2.67vh;
        font-size: 1.8vh;
    }

    .resetform input,
    .resetform button {
        width: 28.6vh;
        padding: 1.42vh;
        margin-bottom: 2.5vh;
        font-size: 1.78vh;
    }

    .resetform button {
        width: 31.46vh;
        margin-bottom: 0;
    }
</style>